import React from 'react';

interface Props {
    readonly header: string;
    readonly subHeader: string;
    readonly headerWidth?: string;
    readonly subHeaderWidth?: string;
    readonly subHeaderPadding?: string;
}

function BioPageHeader({
    header,
    subHeader,
    headerWidth = '',
    subHeaderWidth = '',
    subHeaderPadding = 'pb-10',
}: Props) {
    const headerClassName = `font-jazmin text-2xl text-cleanSlate ${headerWidth}`;
    const subHeaderClassName = `text-cleanSlate pt-2 font-normal text-base font-instrument leading-6 ${subHeaderWidth}`;

    return (
        <div>
            <div className="flex items-center gap-3">
                <img className="w-20 h-20 hidden sm:flex" src="/images/bio/goose-avatar.png" alt="goose-avatar" />
                <h2 className={headerClassName}>
                    {header}
                </h2>
            </div>
            <div className={subHeaderPadding}>
                <p className={subHeaderClassName}>
                    {subHeader}
                </p>
            </div>
        </div>
    );
}

export default BioPageHeader;
